$(document).ready(function() {
    $('#outcome-buy-buttons').on('click', function() {
        $('.shopify-payment-button__button').click();
    });
});

function updateZecpeAttr() {
  var btn = document.getElementById("outcome-buy-buttons");
  
  if (btn) {
    if (btn.getAttribute("data-function") !== "ZecpeCheckVariant") {
      btn.setAttribute("data-function", "ZecpeCheckVariant");
    }

    if (!btn.classList.contains("zecpe-btn")) {
      btn.classList.add("zecpe-btn");
    }
  }
}


// Run immediately
updateZecpeAttr();

setTimeout(updateZecpeAttr, 500);
setTimeout(updateZecpeAttr, 1500);
setTimeout(updateZecpeAttr, 3000);

// Observe DOM changes (MOST IMPORTANT)
const observer = new MutationObserver(() => {
  updateZecpeAttr();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true
});

document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
      item.querySelector('.faq-que').addEventListener('click', () => {

        faqItems.forEach(other => {
          if (other !== item) {
            other.classList.remove('active');
          }
        });

        item.classList.toggle('active');
      });
    });
  });



// Landing Page

// document.addEventListener("DOMContentLoaded", function () {

//   /* LANDING PAGE → PRODUCT REDIRECT */
//   document.querySelectorAll(".zecpe-btn").forEach(btn => {
//     btn.addEventListener("click", function () {
//       const variantId = this.dataset.variantId;
//       window.location.href = `/products/free-5-day-sample-medicine?variant=${variantId}&autoCheckout=1`;
//     });
//   });

//   /* PRODUCT PAGE → AUTO APP CHECKOUT */
//   const urlParams = new URLSearchParams(window.location.search);

//   if (urlParams.get('autoCheckout') === '1') {

//     const interval = setInterval(() => {
//       const appButton = document.querySelector('.shopify-payment-button__button');

//       if (appButton) {
//         appButton.click();
//         clearInterval(interval);
//       }
//     }, 300);

//     setTimeout(() => clearInterval(interval), 1000);
//   }

// });